// Shopify owns country, market, cart and language. This code never converts a price.
(() => {
 const root=document.querySelector('dime-market'),form=root?.querySelector('form');if(!form)return;
 const country=form.querySelector('[name="country_code"]'),language=form.querySelector('[name="language_code"]');
 if(!country||!language)return;
 const storageKey='dime-market-choice-v2';let automatic=false,userInteracted=false;
 const read=()=>{try{return localStorage.getItem(storageKey)}catch{return 'storage-unavailable'}};
 const remember=()=>{try{localStorage.setItem(storageKey,JSON.stringify({country:country.value,at:Date.now()}))}catch{}};
 const supported=(field,value)=>[...field.options].some(o=>o.value===value);
 const interacted=()=>{userInteracted=true};
 form.addEventListener('input',interacted);
 form.addEventListener('change',interacted);
 country.addEventListener('change',()=>{interacted();const wanted=country.value==='TR'?'tr':'en';if(supported(language,wanted))language.value=wanted});
 language.addEventListener('change',interacted);
 form.addEventListener('submit',()=>{remember();if(!automatic){interacted();form.setAttribute('aria-busy','true')}});
 // A localized link is an explicit language choice, even on a first visit.
 const localized=root.dataset.localeRoot && root.dataset.localeRoot!=='/';
 // Respect an explicit country choice. A failed lookup leaves the native country selector usable.
 if(!read()&&!window.Shopify?.designMode&&typeof AbortSignal!=='undefined'&&typeof AbortSignal.timeout==='function'){
   fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true',{credentials:'same-origin',redirect:'error',signal:AbortSignal.timeout(5000)})
   .then(r=>r.ok?r.json():null).then(data=>{
     if(userInteracted||read())return;
     const code=data?.detected_values?.country?.handle;
     if(typeof code!=='string'||!/^[A-Z]{2}$/.test(code)||!supported(country,code))return;
     const preferred=code==='TR'?'tr':'en';
     const wanted=!localized&&supported(language,preferred)?preferred:language.value;
     if(code!==country.value||wanted!==language.value){country.value=code;language.value=wanted;automatic=true;form.requestSubmit()}
     else remember();
   }).catch(()=>{});
 }
})();
